/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createLoanGetResponseFromDiscriminatorValue, serializeLoanPostRequest, type LoanGetResponse, type LoanPostRequest } from '../models';
// @ts-ignore
import { type WithLoanItemRequestBuilder, WithLoanItemRequestBuilderRequestsMetadata } from './item';
// @ts-ignore
import { OverviewRequestBuilderRequestsMetadata, type OverviewRequestBuilder } from './overview';
// @ts-ignore
import { type BaseRequestBuilder, type Guid, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /loans
 */
export interface LoansRequestBuilder extends BaseRequestBuilder<LoansRequestBuilder> {
    /**
     * The overview property
     */
    get overview(): OverviewRequestBuilder;
    /**
     * Gets an item from the MoneyChecker.Web.ApiClient.loans.item collection
     * @param loanId The Guid identifier of the loan to retrieve
     * @returns {WithLoanItemRequestBuilder}
     */
     byLoanId(loanId: Guid) : WithLoanItemRequestBuilder;
    /**
     * Retrieves a list of all loans
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<LoanGetResponse[]>}
     */
     get(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<LoanGetResponse[] | undefined>;
    /**
     * Creates a new loan
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<Guid>}
     */
     post(body: LoanPostRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<Guid | undefined>;
    /**
     * Retrieves a list of all loans
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
    /**
     * Creates a new loan
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: LoanPostRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const LoansRequestBuilderUriTemplate = "{+baseurl}/loans";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const LoansRequestBuilderNavigationMetadata: Record<Exclude<keyof LoansRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    byLoanId: {
        requestsMetadata: WithLoanItemRequestBuilderRequestsMetadata,
        pathParametersMappings: ["loanId"],
    },
    overview: {
        requestsMetadata: OverviewRequestBuilderRequestsMetadata,
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const LoansRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: LoansRequestBuilderUriTemplate,
        responseBodyContentType: "text/plain;q=0.9",
        adapterMethodName: "sendCollection",
        responseBodyFactory:  createLoanGetResponseFromDiscriminatorValue,
    },
    post: {
        uriTemplate: LoansRequestBuilderUriTemplate,
        responseBodyContentType: "text/plain;q=0.9",
        adapterMethodName: "sendPrimitive",
        responseBodyFactory:  "string",
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeLoanPostRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
